import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HubDatepickerComponent } from './hub-datepicker/hub-datepicker.component';
import { CalendarModule } from 'primeng/calendar';
import { DazzleIconComponent } from '../shared/dazzle-icons/dazzle-icon.component';
import { CommonModule } from '@angular/common';
import { DropdownModule } from 'primeng/dropdown';
import { HubDropdownComponent } from './hub-dropdown/hub-dropdown.component';
import { CheckboxModule } from 'primeng/checkbox';
import { HubInputComponent } from './hub-input/hub-input.component';
import { InputTextModule } from 'primeng/inputtext';
import { HubButtonIconOnlyComponent } from './hub-button-icon-only/hub-button-icon-only.component';
import { HubTextAreaComponent } from './hub-text-area/hub-text-area.component';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { HubButtonComponent } from './hub-button/hub-button.component';
import { HubFilterChipComponent } from './hub-filter-chip/hub-filter-chip.component';
import { HubModalHeaderComponent } from './hub-modal-header/hub-modal-header.component';
import { HubCheckboxComponent } from './hub-checkbox/hub-checkbox.component';
import { HubAutocompleteComponent } from './hub-autocomplete/hub-autocomplete.component';
import { AutoCompleteModule } from 'primeng/autocomplete';
import {ProgressSpinnerModule} from 'primeng/progressspinner';

@NgModule({
  declarations: [
    HubDatepickerComponent,
    HubDropdownComponent,    
    HubInputComponent,
    HubButtonIconOnlyComponent,
    HubTextAreaComponent,
    HubButtonComponent,
    HubFilterChipComponent,
    HubModalHeaderComponent,
    HubCheckboxComponent,
    HubAutocompleteComponent,
  ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CalendarModule,
    DazzleIconComponent,
    CommonModule,
    DropdownModule,
    CheckboxModule,
    InputTextModule,
    InputTextareaModule,
    AutoCompleteModule,
    ProgressSpinnerModule
  ],
  exports: [
    HubDatepickerComponent,
    HubDropdownComponent,
    HubInputComponent,
    HubButtonIconOnlyComponent,
    HubTextAreaComponent,
    HubButtonComponent,
    HubFilterChipComponent,
    HubModalHeaderComponent,
    HubCheckboxComponent,
    HubAutocompleteComponent,
  ],
})
export class HubUIModule {}
